import { render, staticRenderFns } from "./ToggleListItem.vue?vue&type=template&id=5b0cfa52&scoped=true"
import script from "./ToggleListItem.vue?vue&type=script&lang=js"
export * from "./ToggleListItem.vue?vue&type=script&lang=js"
import style0 from "./ToggleListItem.vue?vue&type=style&index=0&id=5b0cfa52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0cfa52",
  null
  
)

export default component.exports